import { useEffect } from 'react'

const OfficeSection = () => {
  const officeImages = [
    '/img/about-us/2.jpg',
    '/img/about-us/3.jpg',
    '/img/about-us/4.jpg',
    '/img/about-us/5.jpg',
    '/img/about-us/6.jpg',
    '/img/about-us/7.jpg',
  ]

  useEffect(() => {
    // Initialize seamless scroll animation for office photos
    const initOfficeScroll = () => {
      const wrapper = document.querySelector(
        '.scroll-wrapper-office'
      ) as HTMLElement
      if (!wrapper) return

      const slides = wrapper.querySelectorAll('.image-slider-lg')
      if (slides.length === 0) return

      // Create container for animation
      const container = document.createElement('div')
      container.style.display = 'flex'
      container.style.transition = 'none'

      // Clone slides multiple times for seamless loop
      for (let i = 0; i < 3; i++) {
        slides.forEach((slide) => {
          const clonedSlide = slide.cloneNode(true) as HTMLElement
          container.appendChild(clonedSlide)
        })
      }

      // Replace wrapper content
      wrapper.innerHTML = ''
      wrapper.appendChild(container)

      // Animation variables
      let position = 0
      const slideWidth = window.innerWidth < 768 ? 280 : 508
      const totalSlides = slides.length
      const resetPoint = slideWidth * totalSlides
      const speed = 0.5

      let isPaused = false

      const animate = () => {
        if (!isPaused) {
          position -= speed
          if (position <= -resetPoint) {
            position = 0
          }
          container.style.transform = `translateX(${position}px)`
        }
        requestAnimationFrame(animate)
      }

      animate()

      // Pause on hover
      wrapper.addEventListener('mouseenter', () => {
        isPaused = true
      })
      wrapper.addEventListener('mouseleave', () => {
        isPaused = false
      })
    }

    // Initialize with delay
    setTimeout(initOfficeScroll, 200)
  }, [])

  return (
    <section className="flex flex-col items-center justify-center bg-[#f7f8ff] py-16">
      <div className="w-full">
        {/* Section Title */}
        <div className="mb-6 text-center md:mb-8">
          <h2 className="mb-4 font-['Poppins'] text-xl font-bold md:mb-6 md:text-2xl lg:text-3xl">
            <span className="text-[#d91f2e]"> Kantor</span>
            <span className="text-[#475467]"> Kami</span>
          </h2>

          <p className="mx-auto max-w-[923px] px-4 text-center font-['Poppins'] text-sm font-normal leading-5 text-[#475467] md:px-0 md:text-base md:leading-6">
            Di sinilah semua ide keren, obrolan seru, dan rencana besar untuk
            membantu talenta Indonesia kerja ke Jepang dimulai. Kadang serius,
            kadang ketawa bersama, tapi selalu fokus bantu kamu berkembang.
          </p>

          {/* Office Location */}
          <div className="flex inline-flex items-center justify-center gap-3 rounded-[30px] border border-[#475467] px-5 py-2">
            <img
              src="/img/about-us/Vector_6.svg"
              alt="Location icon"
              className="h-[25px] w-[21px] object-cover"
            />
            <span className="font-['Poppins'] text-[15px] font-normal text-[#475467]">
              The Icon Business Park BSD, Tangerang
            </span>
          </div>
        </div>

        {/* Office Photos Scrolling Section */}
        <div className="w-full overflow-hidden">
          <div className="scroll-wrapper-office flex items-center overflow-hidden">
            {officeImages.map((image, index) => (
              <img
                key={index}
                src={image}
                alt={`Office photo ${index + 1}`}
                className="image-slider-lg min-h-[167px] max-w-[488px] flex-shrink-0 object-cover pr-3 md:min-h-[325px] md:min-w-[488px] md:pr-4"
                loading="lazy"
                sizes="(max-width: 767px) 100vw, 483px"
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default OfficeSection
